import {IDispatcher, IListener, ISubscription} from '@src/@interfaces/services/Events';
import app from '@src/helpers/app';
import {IStoreEventPayload} from '@src/@interfaces/services/StoreEvents/IStoreEventPayload';
import {IStoreEvents} from '@src/@interfaces/services/StoreEvents/IStoreEvents';

export default class StoreEvents implements IStoreEvents {
    protected EVENTS_NAME_PREFIX = 'store@';
    protected ANY_ACTION_DISPATCHED_EVENT_NAME = 'action-fired';

    protected dispatcherInstance?: IDispatcher;

    dispatch(actionType: string, payload: IStoreEventPayload): void {
        this.dispatcher.dispatch(this.getEventName(), payload);
        this.dispatcher.dispatch(this.getEventName(actionType), payload);
    }

    listen<TPayload = any>(actionType: string | 'any' | Array<string | 'any'>, listener: IListener<IStoreEventPayload<TPayload>>): ISubscription {
        const types = (
            Array.isArray(actionType) ? actionType : [actionType]
        ).map(type => this.getEventName(type === 'any' ? undefined : type));

        return this.dispatcher.listen(types, listener);
    }

    listenAny<TPayload = any>(listener: IListener<IStoreEventPayload<TPayload>>): void {
        this.listen('any', listener);
    }

    protected getEventName(actionName?: string): string {
        return this.EVENTS_NAME_PREFIX + (actionName ?? this.ANY_ACTION_DISPATCHED_EVENT_NAME);
    }

    protected get dispatcher() {
        return this.dispatcherInstance ??= app('events');
    }
}
